module.exports = __webpack_public_path__ + "media/img/help_center/Student_Manage_Application_05-2d735456e7b4650fef1c4a4a603d4373.jpg";